import React, { useState, useEffect } from "react";
import { ToastContainer, toast } from "react-toastify";
import "./css/styles.css";
import {
  Card,
  Dialog,
  DialogActions,
  DialogTitle,
  Button,
  TextField,
  FormControl,
  Box,
  Modal,
  Select,
  MenuItem,
  InputLabel,
} from "@mui/material";
import { muiAbtn, muiBbtn } from "./style";
import CloseIcon from "@mui/icons-material/Close";
import AddIcon from "@mui/icons-material/Add";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import { useNavigate } from "react-router-dom";
import {
  collection,
  getDocs,
  addDoc,
  setDoc,
  getDoc,
  updateDoc,
  doc,
  query,
  orderBy,
  onSnapshot,
  deleteDoc,
} from "firebase/firestore";
import { db } from "../firebase";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 500,
  bgcolor: "#fff",
  boxShadow: 24,
  p: 4,
  boxShadow: "rgba(149, 157, 165, 0.2) 0px 8px 24px",
};

export default function AddCuturalResources() {
  const navigate = useNavigate();

  const [loading, setLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [newLink, setNewLink] = useState("");
  const [countries, setCountries] = useState([]);
  const [selectedCountry, setSelectedCountry] = useState(null);
  const [description, setDescription] = useState("");
  const [category, setCategory] = useState("");
  const [diplomaticCountries, setDiplomaticCountries] = useState([]);
  const categories = ["Religious sources", "UNESCO resources", "Cuisine", "Music", "Dance", "Architecture", "Art", "Mythology", "Philosophy", "Literature", "Folk culture"];

  const handleOpen = () => {
    setOpen(true);
    setNewLink("");
    setSelectedCountry(null);
  };

  const handleClose = () => {
    setOpen(false);
    setNewLink("");
    setDescription("");
    setCategory("");
    setSelectedCountry(null);
  };


  const getData = () => {
    setLoading(true);
  
    const q = query(collection(db, "countries"), orderBy("name", "asc"));
  
    const unsubscribe = onSnapshot(q, async (snapshot) => {
      const updatedRows = [];
      var diplomaticRows = [];
  
      // Create an array of promises to handle async operations
      const promises = snapshot.docs.map(async (document) => {
        const data = document.data();
        updatedRows.push(data);
        
        const querySnapshot = await getDocs(collection(db, "cultural_resources"));
       diplomaticRows = querySnapshot.docs.map((doc) => ({
          id: doc.id, // Document ID
          ...doc.data() // Document data
        }));
        
      });
  
      // Wait for all promises to resolve
      await Promise.all(promises);
  
      // Now set the state after all async operations have finished
      setCountries(updatedRows);
      setDiplomaticCountries(diplomaticRows);
      console.log("here is array: ", diplomaticRows);
      setLoading(false);
    });
  
    return unsubscribe;
  };
  
  useEffect(() => {
    let unsubscribe;
    let active = true;

    if (active) {
      unsubscribe = getData();
    }

    return () => {
      active = false;
      if (unsubscribe) {
        unsubscribe();
      }
    };
  }, []);

  useEffect(() => {
    if (!loading && countries.length < 0) {
      toast.error("Countries could not load!");
    }
  }, [loading, countries]);

  const handleSaveLink = async () => {
    if (selectedCountry && newLink && description && category) {
      try {
        // const countryDoc = doc(db, "cultural_resources");
        // await setDoc(countryDoc, {
        //     description: description,
        //     category: category,
        //     url: newLink,
        //     countryRef: selectedCountry.id
        // });
        const docRef = await addDoc(collection(db, "cultural_resources"), {
          description: description,
            category: category,
            url: newLink,
            countryId: selectedCountry.id
        });
        toast.success("Schools Link added successfully!");
        handleClose();
      } catch (error) {
        console.log(error);
        toast.error("Failed to add the link.");
      }
    } else {
      toast.error("Please select a country and enter a link.");
    }
  };

  const handleEditLink = (country) => {

    const selected = countries.find(
        (c) => c.id === country.countryId
      );

    setSelectedCountry(selected);
    setNewLink(country.url || "");
    setDescription(country.description || "");
    setCategory(country.category || "");
    setOpen(true);
  };

  const handleDeleteLink = async (id) => {
    try {
      const countryDoc = doc(db, "cultural_resources", id);
      await deleteDoc(countryDoc);
      toast.success("Cultural Resource Deleted successfully!");
    } catch (error) {
      toast.error("Failed to remove the Resource.");
    }
  };

  return (
    <>
      <div
        style={{
          width: "100%",
          padding: 40,
          paddingRight: 20,
          backgroundColor: "#212C62",
        }}
      >
        <ToastContainer
          position="top-center"
          autoClose={5000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
          theme="colored"
        />

        <Modal
          open={open}
          onClose={handleClose}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box sx={style}>
            <form>
              <Box style={{ display: "flex", justifyContent: "end" }}>
                <CloseIcon
                  onClick={handleClose}
                  style={{ cursor: "pointer", color: "gray" }}
                />
              </Box>
              <h2 className="mb-4" style={{ color: "#212C62" }} mb={3}>
                {selectedCountry ? "Edit School List" : "Add New List"}
              </h2>

              <FormControl fullWidth size="small" className="mb-4">
                <InputLabel id="country-select-label">Select Country</InputLabel>
                <Select
                  labelId="country-select-label"
                  id="country-select"
                  value={selectedCountry ? selectedCountry.name : ""}
                  label="Select Country"
                  onChange={(e) => {
                    const selected = countries.find(
                      (country) => country.name === e.target.value
                    );
                    setSelectedCountry(selected);
                  }}
                //   disabled={!!selectedCountry}
                >
                  {countries.map((country, index) => (
                    <MenuItem key={index} value={country.name}>
                      {country.name}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>

              <FormControl fullWidth size="small" className="mb-4">
                <InputLabel id="country-select-label">Select Category</InputLabel>
                <Select
                  labelId="country-select-label"
                  id="country-select"
                  value= {category}
                  label="Select Category"
                  onChange={(e) => {
                    const selected = categories.find(
                      (category) => category === e.target.value
                    );
                    setCategory(selected);
                  }}
                //   disabled={!!category}
                >
                  {categories.map((category, index) => (
                    <MenuItem key={index} value={category}>
                      {category}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>

              <FormControl fullWidth size="small">
                <TextField
                  className="mb-4"
                  id="outlined-basic"
                  label="Description"
                  variant="outlined"
                  size="small"
                  fullWidth
                  value={description}
                  onChange={(e) => setDescription(e.target.value)}
                />
              </FormControl>

              <FormControl fullWidth size="small">
                <TextField
                  className="mb-4"
                  id="outlined-basic"
                  label="Enter Link"
                  variant="outlined"
                  size="small"
                  fullWidth
                  value={newLink}
                  onChange={(e) => setNewLink(e.target.value)}
                />
              </FormControl>

              <Button
                fullWidth
                className="mt-2 muibtn"
                variant="contained"
                color="primary"
                size="small"
                style={muiBbtn}
                onClick={handleSaveLink}
              >
                <>
                  <AddIcon style={{ marginRight: 10 }} />
                  {"Add Cultural Recource"}
                </>
              </Button>
            </form>
          </Box>
        </Modal>

        <Card style={{ padding: 50, borderRadius: 10 }}>
          <div className="row d-flex justify-content-between">
            <div className="col-6">
              <h1
                className="mb-4 py-4"
                style={{ textAlign: "left", color: "#212C62" }}
              >
                <b>Cultural Resources Per Country</b>
              </h1>
              <Button
                variant="contained"
                color="primary"
                style={muiBbtn}
                size="small"
                onClick={handleOpen}
              >
                Add Cultural Resources
              </Button>
            </div>
          </div>

          <div>
            <h3 style={{ marginTop: 20, color: "#212C62" }}>
              Countries with Schools Links
            </h3>
            {diplomaticCountries && diplomaticCountries.length > 0 ? (
              diplomaticCountries.map((country, index) => (
                <div
                  key={index}
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    marginBottom: 10,
                  }}
                >

                    <span style={{ fontSize: 18 }}>{country.category}</span>
                    <span style={{ fontSize: 18 }}>{country.description}</span>
                  <div>
                    <Button
                      variant="contained"
                      color="primary"
                      size="small"
                      style={{ marginRight: 10 }}
                      onClick={() => handleEditLink(country)}
                    >
                      <EditIcon />
                      Edit
                    </Button>
                    <Button
                      variant="contained"
                      color="secondary"
                      size="small"
                      onClick={() => handleDeleteLink(country.id)}
                    >
                      <DeleteIcon />
                      Delete
                    </Button>
                  </div>
                </div>
              ))
            ) : (
              <p>No countries with cultural resources.</p>
            )}
          </div>
        </Card>
      </div>
    </>
  );
}